import t from 'tcomb';

const is_uuid_regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const UUID = t.refinement(t.String, (s) => is_uuid_regexp.test(s));

export default UUID;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/UUID.js
 **/